import { render, staticRenderFns } from "./CreateAccessLevel.vue?vue&type=template&id=0f93b413"
import script from "./CreateAccessLevel.vue?vue&type=script&lang=js"
export * from "./CreateAccessLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports